import config from "../../config";

const menus = [
	// @DASHBOARD
	{
		id: "dashboard",
		link: "/",
		label: "Дашборд",
		icon: "menu-analytic"
	},
	// @STORAGE
	{
		id: "storages",
		label: "Склад",
		icon: "menu-storage",
		children: [
			{
				id: "comings",
				link: "/storage/incomes",
				label: "Приход товаров"
			},
			{
				id: "consumption",
				link: "/storage/consumption",
				label: "Расход товаров"
			},
			{
				id: "storages",
				link: "/storages",
				label: "Остаток"
			},
			{
				id: "comings",
				link: "/storage/comings",
				label: "Журнал приходов"
			},
			{
				id: "transfer",
				link: "/storage/transfers",
				label: "Перемещение"
			},
			{
				id: "adjustments",
				link: "/storage/adjustments",
				label: "Инвентаризация"
			}
		]
	},
	// @USERS
	{
		id: "users",
		label: "Пользователи",
		icon: "menu-hr",
		children: [
			// {
			// 	id: "users-cashier",
			// 	label: "Кассир",
			// 	link: `/users?role=${config.USER_ROLE_CASHIER}`,
			// 	role: "cashier"
			// },
			// {
			// 	id: "users-waiter",
			// 	label: "Агент",
			// 	link: `/users?role=${config.USER_ROLE_WAITER}`,
			// 	role: "waiter"
			// },
			// {
			// 	id: "users-courier",
			// 	label: "Курьер",
			// 	link: `/users?role=${config.USER_ROLE_COURIER}`,
			// 	role: "courier"
			// },
			// {
			// 	id: "users-mono",
			// 	label: "Моноблок",
			// 	link: `/users?role=${config.USER_ROLE_MONO}`,
			// 	role: "mono"
			// },
			// {
			// 	id: "users-kitchener",
			// 	label: "Другие сотрудники",
			// 	link: `/users?role=${config.USER_ROLE_KITCHENER}`,
			// 	role: "kitchener"
			// },
			{
				id: "users-manager",
				label: "Менеджер",
				link: `/users?role=${config.USER_ROLE_MANAGER}`,
				role: "manager"
			}
			// {
			// 	id: "users-warehouse",
			// 	label: "Завсклад",
			// 	link: `/users?role=${config.USER_ROLE_WAREHOUSE}`,
			// 	role: "warehouse"
			// },
			//   {
			//     id: "attendance-users",
			//     link: "/users/attendance",
			//     title: "attendance",
			//     role: "users",
			//   },
			// {
			// 	id: "users-attendance",
			// 	label: "Посещаемость",
			// 	link: `/users/${config.USER_ROLE_ATTENDANCE}`,
			// 	role: "attendance"
			// }
		]
	},

	// @REPORTS
	{
		id: "reports",
		label: "Отчеты",
		icon: "menu-report",
		children: [
			// {
			//   id: "reports/z",
			//   link: "/report/z",
			//   label: "Z - Отчёт",
			// },
			{
				id: "reports/order",
				link: "/report/orders",
				label: "Отчёт по заказам"
			},
			{
				id: "reports/order-table",
				link: "/report/orders-table",
				label: "Отчёт по столам"
			},
			{
				id: "reports/waiter",
				link: "/report/waiter",
				label: "Отчет по Агентам"
			},
			{
				id: "reports/dishes",
				link: "/report/dishes",
				label: "Отчёт по продуктам"
			},
			{
				id: "reports/returned-dishes",
				link: "/report/returned-dishes",
				label: "Отчет о возвращенных товарах"
			},
			{
				id: "reports/debt-credit",
				link: "/reports/debt-credit",
				label: "Дебиторы и кредиторы"
			}
			// {
			//     id: "reports/storage-material",
			//     link: "/reports/storage-material",
			//     label: "Материальный отчёт склада",
			// },
			// {
			//   id: "reports/cashflow",
			//   link: "/reports/cashflow",
			//   label: "Денежный поток",
			// },
		]
	},
	// @FINANCE
	{
		id: "finance",
		label: "Финансы",
		icon: "menu-finance",
		children: [
			{
				id: "transactions",
				link: "/transactions",
				label: "Денежные операции"
			},
			{
				id: "category/income",
				link: "/transactions/categories/income",
				label: "Категория приходов"
			},
			{
				id: "category/expense",
				link: "/transactions/categories/expense",
				label: "Категория расходов"
			}
		]
	},
	// @NOMENCLATURE
	{
		id: "nomenclature",
		label: "Номенклатура",
		icon: "menu-storage",
		cols: 4,
		children: [
			{
				id: "dish",
				link: "/dish",
				label: "Продукт"
			},
			{
				id: "materials",
				link: "/materials",
				label: "Сырьё"
			},
			{
				id: "semi-finished-products",
				link: "/semi-finished-products",
				label: "Полуфабрикаты"
			},
			{
				id: "dish-category",
				link: "/dish-categories",
				label: "Категория блюд"
			},
			{
				id: "material-category",
				link: `/categories/${config.CATEGORY_MATERIAL}`,
				label: "Категория сырьё"
			},
			{
				id: "half-product-category",
				link: `/categories/${config.CATEGORY_HALF_FINISHED}`,
				label: "Категория полуфабрикатов"
			},
			{
				id: "product-category",
				link: `/categories/${config.CATEGORY_PRODUCT}`,
				label: "Категория реализации"
			}
		]
	},

	// @SETTINGS
	{
		id: "settings",
		label: "Настройки",
		icon: "menu-setting",
		children: [
			{
				id: "payment-types",
				link: "/handbook/payment-types",
				label: "Способ оплаты"
			},
			{
				id: "printers",
				link: "/settings/printers",
				label: "Настройка принтеров"
			},
			{
				id: "profile-settings",
				link: "/settings/new-settings",
				label: "Настройка профиля"
			},
			{
				id: "counterparties",
				label: "Клиенты",
				icon: "menu-clients",
				link: "/counterparties"
			}
			// {
			//   id: "places",
			//   link: "/places",
			//   label: "Место",
			// },
			// {
			//   id: "units",
			//   link: "/handbook/units",
			//   label: "Единица измерения",
			// },
			// {
		]
	}
];
const warehouseMenus = [
	{
		id: "storages",
		label: "Склад",
		icon: "menu-storage",
		children: [
			{
				id: "comings",
				link: "/storage/incomes",
				label: "Приход товаров"
			},
			{
				id: "consumption",
				link: "/storage/consumption",
				label: "Расход товаров"
			},
			{
				id: "storages",
				link: "/storages",
				label: "Остаток"
			},
			{
				id: "comings",
				link: "/storage/comings",
				label: "Журнал приходов"
			},
			{
				id: "transfer",
				link: "/storage/transfers",
				label: "Перемещение"
			},
			{
				id: "adjustments",
				link: "/storage/adjustments",
				label: "Инвентаризация"
			}
		]
	},
	{
		id: "nomenclature",
		label: "Номенклатура",
		icon: "menu-storage",
		cols: 3,
		children: [
			{
				id: "dish",
				link: "/dish",
				label: "Продукт"
			},
			{
				id: "materials",
				link: "/materials",
				label: "Сырьё"
			},
			{
				id: "semi-finished-products",
				link: "/semi-finished-products",
				label: "Полуфабрикаты"
			},
			{
				id: "dish-category",
				link: "/dish-categories",
				label: "Категория блюд"
			},
			{
				id: "material-category",
				link: `/categories/${config.CATEGORY_MATERIAL}`,
				label: "Категория сырьё"
			},
			{
				id: "half-product-category",
				link: `/categories/${config.CATEGORY_HALF_FINISHED}`,
				label: "Категория полуфабрикатов"
			},
			{
				id: "product-category",
				link: `/categories/${config.CATEGORY_PRODUCT}`,
				label: "Категория реализации"
			}
		]
	}
];

export const getTechCardMenu = () => {
	return [
		{
			id: "nomenclature",
			label: "Номенклатура",
			icon: "menu-storage",
			cols: 4,
			children: [
				{
					id: "dish",
					link: "/dish",
					label: "Продукт",
					role: "dish"
				},
				{
					id: "materials",
					link: "/materials",
					label: "Сырьё",
					role: "materials"
				},
				{
					id: "semi-finished-products",
					link: "/semi-finished-products",
					label: "Полуфабрикаты",
					role: "semi_finished_products"
				},
				{
					id: "dish-category",
					link: "/dish-categories",
					label: "Категория блюд",
					role: "dish_categories"
				},
				{
					id: "material-category",
					link: `/categories/${config.CATEGORY_MATERIAL}`,
					label: "Категория сырьё",
					role: "material_categories"
				},
				{
					id: "half-product-category",
					link: `/categories/${config.CATEGORY_HALF_FINISHED}`,
					label: "Категория полуфабрикатов",
					role: "semi_finished_product_categories"
				},
				{
					id: "product-category",
					link: `/categories/${config.CATEGORY_PRODUCT}`,
					label: "Категория реализации",
					role: "implementation_categories"
				}
			]
		}
	];
};

const getMainOrganizationMenu = role => {
	return menus;
};

export default getMainOrganizationMenu;
